// removed by extract-text-webpack-plugin
module.exports = {"modale":"Modal__modale___1h2Zu","modalAumentoDot":"Modal__modalAumentoDot___14t1q"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/components/shared/Modal.css
// module id = 722
// module chunks = 0